import { Box } from '@mui/material';

interface TypingIndicatorProps {
  isTyping: boolean;
}

export function TypingIndicator({ isTyping }: TypingIndicatorProps) {
  if (!isTyping) return null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <svg width="32" height="24" viewBox="0 0 32 24">
        <style>
          {`
            @keyframes wave-pulse {
              0%, 100% {
                opacity: 0.2;
              }
              33% {
                opacity: 1;
              }
              66% {
                opacity: 0.2;
              }
            }
            .wave-line {
              fill: none;
              stroke: rgb(23, 74, 67);
              stroke-width: 2;
              stroke-linecap: round;
            }
            .wave-1 { animation: wave-pulse 1.2s infinite ease-in-out 0s; }
            .wave-2 { animation: wave-pulse 1.2s infinite ease-in-out 0.2s; }
            .wave-3 { animation: wave-pulse 1.2s infinite ease-in-out 0.4s; }
          `}
        </style>
        <path className="wave-line wave-1" d="M2,6 Q8,2 14,6 T26,6" />
        <path className="wave-line wave-2" d="M2,12 Q8,8 14,12 T26,12" />
        <path className="wave-line wave-3" d="M2,18 Q8,14 14,18 T26,18" />
      </svg>
    </Box>
  );
}
